// modules
import { DBDrop } from '@weblite/persist'
import { showOperationFailedSnackbar } from '$comp/snackbars'
import { restoreSessionStorageOnSignOut } from '$hooks/after/signout.js'
import { storeDBEssentialsOnLocalStorage } from '$logic/client-device'
import { fullReload } from '$func/fullReload'
import { DB_NAME } from '$setup/persist'

export function synchronizePersist() {
  try {
    restoreSessionStorageOnSignOut()
    storeDBEssentialsOnLocalStorage()
    DBDrop(DB_NAME).then(() => {
      // TODO: create db
      fullReload()
    })
  } catch (e) {
    console.error('Failed to remove persist')
    showOperationFailedSnackbar(synchronizePersist)
  }
}
